type QueryValue = string | number | boolean | null | undefined;

function shouldAppendQueryValue(value: QueryValue): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") return value.length > 0;
  if (typeof value === "number") return value !== 0 && !Number.isNaN(value);
  return true;
}

function buildSearchParams(entries: [string, QueryValue][]): URLSearchParams {
  const params = new URLSearchParams();

  entries.forEach(([key, value]) => {
    if (!shouldAppendQueryValue(value)) return;
    params.append(key, `${value}`);
  });

  return params;
}

export function buildQueryFromArray(
  query: [string, string | number | boolean | null | undefined][],
  baseString = ""
): string {
  const queryString = buildSearchParams(query).toString();
  return queryString ? `${baseString}${queryString}` : baseString;
}

export function buildQueryFromObject(
  query: Record<string, QueryValue>,
  baseString = ""
): string {
  const queryString = buildSearchParams(Object.entries(query)).toString();
  return queryString ? `${baseString}${queryString}` : baseString;
}
